import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { RelatieUser } from '../dto/relatie-user';
import { CrudService } from '@mango/core';

@Injectable({ providedIn: 'root' })
export class RelatieUserService extends CrudService<RelatieUser> {

    constructor(injector: Injector) { super(RelatieUser, injector); }

}
